import { StyleSheet, Image, Dimensions } from 'react-native';
import ImagePanZoom from 'react-native-image-pan-zoom';
import Button from './shared/Button';

export default function ImageViewer({ placeholderImageSource, selectedImage, width: customWidth, height: customHeight, aspectRatio = 3 / 2, enablePanZoom = true }) {
    
  const imageSource = selectedImage !== null
    ? { uri: selectedImage }
    : placeholderImageSource;

  const { width: screenWidth } = Dimensions.get('window');
  // Use custom width if provided, otherwise use 100% of available space
  const containerWidth = customWidth || '100%';
  const containerHeight = customHeight || '100%';

  if (!enablePanZoom) {
    // Simple image display without pan/zoom
    return (
      <Image 
        source={imageSource} 
        style={[
          styles.simpleImage, 
          { 
            width: '100%', 
            height: '100%',
          }
        ]} 
        resizeMode="contain" 
      />
    );
  }

  // For pan/zoom, we need explicit dimensions
  const zoomWidth = typeof customWidth === 'number' ? customWidth : screenWidth - 10;
  const zoomHeight = typeof customHeight === 'number' ? customHeight : (zoomWidth / aspectRatio);

  return (
    <ImagePanZoom
      cropWidth={zoomWidth}
      cropHeight={zoomHeight}
      imageWidth={zoomWidth}
      imageHeight={zoomHeight}
      enableDoubleClickZoom={true}
      enableCenterFocus={false}
      minScale={1}
      maxScale={3}
      style={styles.container}
    >
      <Image 
        source={imageSource} 
        style={[styles.image, { width: '100%', aspectRatio }]} 
        resizeMode="contain" 
      />
    </ImagePanZoom>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    aspectRatio: 3/2,
  },
  image: {
    width: '100%',
    aspectRatio: 3/2,
  },
  simpleImage: {
    flex: 1,
    borderRadius: 8,
  },
});
